var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElongatedCushion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.4815 12.0346H38.7776C28.5493 12.0346 20.2576 20.3263 20.2576 30.5545V48.4456C20.2576 58.6739 28.5493 66.9656 38.7776 66.9656H40.4815C50.7098 66.9656 59.0014 58.6739 59.0014 48.4456V30.5545C59.0014 20.3263 50.7098 12.0346 40.4815 12.0346Z",
    stroke: "#4B4B4B",
    strokeWidth: 1.38572,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3007 19.7833L29.4872 40.0072L33.9498 59.3182L39.6295 53.5371L46.1815 58.8517L49.7313 39.5406L45.8975 19.7833L39.6295 25.2805L33.3007 19.7833Z",
    stroke: "#4B4B4B",
    strokeWidth: 1.38572,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6971 28.4448C58.6971 28.4448 48.6156 29.3779 39.6498 25.2804C32.3879 29.8445 20.643 28.7288 20.643 28.7288",
    stroke: "#4B4B4B",
    strokeWidth: 1.38572,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4392 13.5965L45.8975 19.7833L39.6093 12.5011L33.3007 19.7833L31.0897 13.9007",
    stroke: "#4B4B4B",
    strokeWidth: 1.38572,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6971 50.8391C58.6971 50.8391 51.5772 47.8572 39.6498 53.537C27.2559 48.0398 20.7039 51.1231 20.7039 51.1231",
    stroke: "#4B4B4B",
    strokeWidth: 1.38572,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5954 64.9168L46.1815 58.8517L40.1163 66.499L33.9498 59.3182",
    stroke: "#4B4B4B",
    strokeWidth: 1.38572,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0651 28.8505L20.5822 39.5L25.5722 50.2712L29.4872 40.0071L25.0651 28.8505Z",
    stroke: "#4B4B4B",
    strokeWidth: 1.38572,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3007 19.7832L25.0651 18.2213V28.8505",
    stroke: "#4B4B4B",
    strokeWidth: 1.38572,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8975 19.7832L54.2142 18.2213V28.5057L49.7313 39.5405L54.2142 50.048L58.6971 38.5263",
    stroke: "#4B4B4B",
    strokeWidth: 1.38572,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6971 38.5264L54.2142 28.5057",
    stroke: "#4B4B4B",
    strokeWidth: 1.38572,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2142 50.048L54.7416 60.1701L46.1815 58.8516",
    stroke: "#4B4B4B",
    strokeWidth: 1.38572,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5722 50.2712L25.0651 60.7787L33.9498 59.3182L31.6374 65.3224",
    stroke: "#4B4B4B",
    strokeWidth: 1.38572,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElongatedCushion);
export default __webpack_public_path__ + "static/media/ElongatedCushion.31175e5287a53382dfad8695d0358512.svg";
export { ForwardRef as ReactComponent };